/**
 * Z-Index hierarchy constants for the application.
 *
 * These values define the stacking order of UI elements.
 * Higher values appear above lower values.
 *
 * Based on PrimeNG's default z-index configuration:
 * - Base overlay: 1000
 * - Modal: 1100
 * - Tooltip: 1100
 */

/**
 * Z-index for base overlays (dropdowns, menus, etc.)
 * Used by PrimeNG components like TreeSelect
 */
export const Z_INDEX_OVERLAY = 1000;

/**
 * Z-index for modal dialogs and overlays
 */
export const Z_INDEX_MODAL = 1100;

/**
 * Z-index for tooltips
 */
export const Z_INDEX_TOOLTIP = 1100;

/**
 * Z-index for dropdowns and selects that need to appear above modals.
 * This ensures that dropdown overlays from components inside modals
 * are still visible and interactive.
 *
 * Used by:
 * - SelectComponent (libs/shared/utility/src/lib/select/select.component.ts)
 * - ReferenceTreeSelectorComponent (libs/shared/dynamic/.../reference-tree-selector/)
 * - PopoverPositionDirective (libs/shared/utility/src/lib/directives/popover-position/)
 */
export const Z_INDEX_POPOVER = 1200;
